<p-card>
    <div class="col-12 sm:col-12 md:col-12 lg:col-12 xl:col-12">
        <ng-content select=":not(app-page-navigation-bar)"></ng-content>
    </div>
</p-card>
<!-- La barra de navegación se proyecta FUERA del p-card: queda full-width y
     pegada al fondo (no "flotando" dentro de la tarjeta). -->
<ng-content select="app-page-navigation-bar"></ng-content>
